const menuPartMagic = () =>{
    if(document.querySelector('.split-menu-img-block__container')){
        document.addEventListener('click', (ev)=>{
            if(!ev.target.classList.contains('split-menu-img-block-li')) return;
            let link = ev.target.querySelector('a');
            link.click();
        })
    }
}
export default menuPartMagic;